export default "__VITE_ASSET__58f50af0__"